import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import PageShell from "../components/sections/PageShell";
import { applySeo } from "../lib/seo";

export default function NotFoundPage() {
  useEffect(
    () =>
      applySeo({
        path: "/404",
        title: "Page not found — Gadget Guy Media",
        description: "That page doesn't exist. Head back home, see the work, or request a free Local AI Audit.",
        robots: "noindex, follow",
      }),
    []
  );

  return (
    <PageShell testId="not-found-page">
      <section className="max-w-4xl mx-auto px-5 md:px-8" style={{ paddingTop: "clamp(64px, 12vh, 140px)", paddingBottom: "clamp(64px, 12vh, 140px)" }}>
        <div className="ggm-eyebrow mb-6">Error 404</div>
        <h1
          className="font-condensed uppercase text-white leading-[1.02]"
          style={{ fontSize: "clamp(2.5rem, 7vw, 5rem)", letterSpacing: "-0.015em" }}
          data-testid="not-found-h1"
        >
          This page went off-orbit.
        </h1>
        <p className="mt-6 font-body text-white/75 text-base md:text-lg max-w-2xl" data-testid="not-found-message">
          The link may be old or mistyped. Here's where most people were headed:
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="ggm-btn-primary" data-testid="not-found-home-link">Back home <ArrowRight size={16} /></Link>
          <Link to="/audit" className="ggm-btn-secondary" data-testid="not-found-audit-link">Free Local AI Audit <ArrowUpRight size={16} /></Link>
          <Link to="/projects" className="ggm-btn-secondary" data-testid="not-found-projects-link">See my work</Link>
        </div>
      </section>
    </PageShell>
  );
}
